import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import Paper from '@material-ui/core/Paper';

import './ScheduleInfo.scss';

const ScheduleInfo = ({
  data: {
    amountOfClaim,
    totalAmount,
    calculatedTotal,
    priorityAmount,
    securedAmount,
    unsecuredAmount,
  },
}) => (
  <Paper className="schedule-info">
    <div className="schedule-info__title">
      Schedule
    </div>
    <div className="schedule-info__content">
      <div className="schedule-info__total">
        <div className="schedule-info__total-label">
          Total amount:
        </div>
        <div className="schedule-info__total-value">
          <NumberFormat
            value={totalAmount + calculatedTotal}
            displayType="text"
            prefix="$"
            thousandSeparator
          />
        </div>
      </div>
      <div className="schedule-info__category">
        <div className="schedule-info__group">
          <div className="schedule-info__label">
            Amount of claim:
          </div>
          <div className="schedule-info__value">
            <NumberFormat
              value={amountOfClaim}
              displayType="text"
              prefix="$"
              thousandSeparator
            />
          </div>
        </div>
        <div className="schedule-info__group">
          <div className="schedule-info__label">
            Secured amount:
          </div>
          <div className="schedule-info__value">
            <NumberFormat
              value={securedAmount}
              displayType="text"
              prefix="$"
              thousandSeparator
            />
          </div>
        </div>
        <div className="schedule-info__group">
          <div className="schedule-info__label">
            Unsecured amount:
          </div>
          <div className="schedule-info__value">
            <NumberFormat
              value={unsecuredAmount}
              displayType="text"
              prefix="$"
              thousandSeparator
            />
          </div>
        </div>
        <div className="schedule-info__group">
          <div className="schedule-info__label">
            Priority amount:
          </div>
          <div className="schedule-info__value">
            <NumberFormat
              value={priorityAmount}
              displayType="text"
              prefix="$"
              thousandSeparator
            />
          </div>
        </div>
      </div>
    </div>
  </Paper>
);

ScheduleInfo.propTypes = {
  data: PropTypes.shape({
    amountOfClaim: PropTypes.string,
    totalAmount: PropTypes.string,
    priorityAmount: PropTypes.string,
    securedAmount: PropTypes.string,
    unsecuredAmount: PropTypes.string,
  }).isRequired,
};

export default ScheduleInfo;



// WEBPACK FOOTER //
// ./src/routes/Case/Claims/ClaimDetails/components/ScheduleInfo/ScheduleInfo.js